import { render, staticRenderFns } from "./CalculationAcls.vue?vue&type=template&id=780dcd5e&scoped=true&"
import script from "./CalculationAcls.vue?vue&type=script&lang=js&"
export * from "./CalculationAcls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "780dcd5e",
  null
  
)

export default component.exports